

    /**
     * Checks if the object is a primitive
     */
    function isPrimitive(value) {
        // Using switch fallthrough because it's simple to read and is
        // generally fast: http://jsperf.com/testing-value-is-primitive/5
        switch (typeof value) {
            case "string":
            case "number":
            case "boolean":
                return true;
        }

        return value == null;
    }

    module.exports = isPrimitive;





/*****************
 ** WEBPACK FOOTER
 ** ./~/mout/lang/isPrimitive.js
 ** module id = 26
 ** module chunks = 0
 **/